"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatCashback = void 0;
var formatCashback = exports.formatCashback = function formatCashback(value) {
  try {
    if (value == null) {
      return '0';
    }
    // Проверяем, является ли value строкой, начинающейся с "+"
    if (typeof value === 'string' && value.startsWith('+')) {
      var numericPart = value.slice(1);
      var _numberValue = parseFloat(numericPart);
      if (isNaN(_numberValue)) {
        return '0';
      }
      return "+ ".concat(Intl.NumberFormat('ru-RU', {
        minimumFractionDigits: 0
      }).format(_numberValue));
    }
    var numberValue = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(numberValue)) {
      return '0';
    }
    return Intl.NumberFormat('ru-RU', {
      minimumFractionDigits: 0
    }).format(numberValue);
  } catch (err) {
    return typeof value === 'string' || typeof value === 'number' ? String(value) : '0';
  }
};